var i = function(t) {
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e ? e.defaultView : window;
  }
  return t;
}, o = function(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}, a = function(t) {
  return i(t).getComputedStyle(t);
}, u = function(t) {
  var e = i(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}, s = function(t) {
  return ["table", "td", "th"].indexOf(o(t)) >= 0;
}, l = function() {
  return typeof window.InstallTrigger < "u";
}, f = function(t) {
  var e;
  return !u(t) || // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
  !(e = t.offsetParent) || // https://github.com/popperjs/popper-core/issues/837
  l() && a(e).position === "fixed" ? null : e;
}, d = function(t) {
  for (var e = i(t), n = f(t); n && s(n); )
    n = f(n);
  return n && o(n) === "body" && a(n).position === "static" ? e : n || e;
};
export {
  d as getOffsetParent
};
